<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <payee-icon
      name="stop-sign"
      class="title-icon"
      height="73px"
      width="auto"
    ></payee-icon>
    <h1>{{ "WORKFLOW_DIALOGS.CLOSE_CASE.CONFIRM_TITLE" | translate }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.CLOSE_CASE.CONFIRM_DESCRIPTION" | translate }}
    </div>
    @if (showCloseReason) {
      <div class="close-reason-hint description">
        {{ "WORKFLOW_DIALOGS.CLOSE_CASE.OTHER_REASON_HINT" | translate }}
      </div>
      <payee-form-field
        width="max"
        height="taller"
        class="close-reason-field"
      >
        <textarea
          payee-input
          [formControl]="closeReasonForm"
          [placeholder]="'WORKFLOW_DIALOGS.CLOSE_CASE.OTHER_REASON_PLACEHOLDER' | translate"
        ></textarea>
      </payee-form-field>
    }
  </ng-template>

  <ng-template #payeePopupSubmitTemplate>
    @if (showCloseReason) {
      <button
        payee-button
        color="alert-red"
        width="max"
        height="normal"
        [disabled]="actionsDisabled"
        [loading]="submitted"
        (click)="confirm()"
      >
        {{ "WORKFLOW_DIALOGS.CLOSE_CASE.CONFIRM_SUBMIT" | translate }}
      </button>
    } @else {
      <button
        payee-button
        color="alert-red"
        width="max"
        height="normal"
        [disabled]="actionsDisabled"
        [loading]="submitted"
        (click)="confirm()"
      >
        {{ "WORKFLOW_DIALOGS.CLOSE_CASE.CONFIRM_SUBMIT" | translate }}
      </button>
    }
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      mat-dialog-close
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
      [disabled]="submitted"
    >
      {{ "WORKFLOW_DIALOGS.CLOSE_CASE.CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
